import { RequireExactlyOne } from "type-fest";
import { v4 as uuid } from "uuid";

import { ICommentResource } from "../../comments";
import { EntityTypes } from "../../EntityTypes";
import { IFollowUpResource } from "../../follow-ups";
import { ISelfEvaluationResource } from "../../self-evaluations";
import { IApiMutationFunction, createApiMutationHook } from "../../utils/api";
import { RelationalValue } from "../../utils/filters";
import { buildResourceIRI } from "../../utils/getResourceUuid";

export type ICommentCreateMutationParameters = RequireExactlyOne<
    {
        uuid?: string;
        content: string;
        followUp: RelationalValue<IFollowUpResource>;
        selfEvaluation: RelationalValue<ISelfEvaluationResource>;
    },
    "followUp" | "selfEvaluation"
>;

export type ICommentCreateMutationResult = ICommentResource;

export const commentCreateMutation: IApiMutationFunction<ICommentCreateMutationParameters> = ({
    followUp,
    selfEvaluation,
    ...data
}) => {
    return {
        method: "POST",
        url: "/comments",
        data: {
            ...data,
            uuid: data.uuid ?? uuid(),
            followUp: buildResourceIRI(EntityTypes.FOLLOW_UP, followUp),
            selfEvaluation: buildResourceIRI(EntityTypes.SELF_EVALUATION, selfEvaluation),
        },
    };
};

export const useCommentCreateMutation = createApiMutationHook<
    ICommentCreateMutationParameters,
    ICommentCreateMutationResult
>(commentCreateMutation);
